import { memo, useRef } from "react";
import classNames from "classnames";
import { ESIInclude } from "../../../__shared__/ESIInclude/ESIInclude";
import styles from "./SocialProofMessages.module.scss";
import { Experiences } from "@/getServerSideProps/monetate/getExperiences/experiencesSchema";
import { encodeExperiencesObject } from "@/utils/monetate/encodeExperiencesObject";

export const SocialProofMessages = memo(function SocialProofMessages({
  productId,
  brand,
  availableToOrder,
  appId,
  experiencesRawObject = [],
  withClose = true,
  className = "",
}: {
  productId: string;
  brand: string;
  availableToOrder: boolean;
  appId: string;
  withClose?: boolean;
  className?: string;
  experiencesRawObject: Experiences;
}) {
  const filteredExperiences = experiencesRawObject?.filter(
    ({ parameters }) => parameters?.fragment === "social-proof-messaging",
  );

  const url = useRef(
    `/esi/social-proof-messaging-ui/?${new URLSearchParams({
      productId,
      brand,
      appId,
      availableToOrder: availableToOrder ? "true" : "false",
      withClose: withClose ? "true" : "false",
      ...(filteredExperiences.length > 0
        ? {
            experiences: encodeExperiencesObject(filteredExperiences),
          }
        : {}),
    }).toString()}`,
  );

  return (
    productId &&
    brand &&
    appId && (
      <div
        data-testid={`social-proof-messaging-${productId}`}
        className={classNames(
          "esi-wrapper",
          styles["social-proof-messages-esi-wrapper"],
          className && styles[className],
        )}
      >
        <ESIInclude
          id={`jl-social-proof-messaging-${productId}`}
          src={url.current}
        />
      </div>
    )
  );
});
